<template>
  <div class="footer">
    <!-- <div class="links">
      <a>大宗电商</a>
      <a>CMS</a>
      <a>大数据</a>
    </div> -->
    <div class="copyright">
      <!-- Copyright -->
      <!-- <a-icon type="copyright"/> -->
      <!-- 2018 <span>中农网研发中心出品</span> -->
      <!-- © 2013 深圳市中农网有限公司. SHENZHEN SINOAGRI E-COMMERCE CO.,LTD. 粤ICP备17148641号-1 -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutFooter',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    margin: 48px 0 24px;
    padding: 0 16px;
    text-align: center;

    .links {
      margin-bottom: 8px;

      a {
        color: rgba(0, 0, 0, .45);

        &:hover {
          color: rgba(0, 0, 0, .65);
        }

        &:not(:last-child) {
          margin-right: 40px;
        }
      }
    }
    .copyright {
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
    }
  }
</style>
